export default {
  en: 'English',
  de: 'Deutsch',
  global: {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    amount: 'Amount',
    noImageAvailable: 'No image available',
    totalPrice: 'Total',
    delete: 'Delete',
    remove: 'Remove',
    restore: 'Restore',
    notes: 'Notes',
    edit: 'Edit',
    downloadPdf: 'Download PDF',
    readMore: 'Read more',
    logout: 'Logout',
    generate: 'Generate',
    back: 'Back',
    forward: 'Forward',
    of: 'of'
  },
  common: {
    error: {
      error: 'An error has occurred',
      unknown: 'Unknown error',
      noAdditionalInfo: 'No further information available.',
      whileCommunicatingWithServer: 'Error while communicating with the server ({errorName})',
      networkIssues: 'Fetch failed, network issue? ({errorName})',
      infoShort: 'Info',
      information: 'Information'
    },
    user: {
      myAccount: 'My account',
      changePassword: 'Change password',
      username: 'Username'
    },
    product: {
      product: 'Product',
      products: 'Products',
      netQuantity: 'Net quantity',
      withSku: '@:common.product.product {sku}',
      withUvp: '@:productDetail.productProperties.grossPrice: {uvp}',
      inBaseUnit: 'in base unit',
      salesUnit: 'Sales unit',
      pricePerUnit: 'Price per unit',
      productImage: 'Product image',
      tieredPrices: 'Tiered prices',
      basePrice: 'Base price',
      productDescription: 'Product description',
      ingredients: 'Ingredients',
      storageNote: 'Storage note',
      allergens: 'Allergens',
      allergencode: {
        gluten: 'Cereals containing gluten',
        crab: 'Crustaceans',
        eggs: 'Eggs',
        fish: 'Fish',
        peanuts: 'Peanuts',
        soy: 'Soybeans',
        milk: 'Milk',
        ediblenut: 'Tree nuts',
        celery: 'Celery',
        mustard: 'Mustard',
        sesame: 'Sesame seeds',
        sulfite: 'Sulphur dioxide and sulphites',
        lupine: 'Lupin',
        molluscs: 'Molluscs',
      },
      attributes: {
        frozen: 'frozen',
        cooled: 'keep refrigerated',
        weigh: 'pay by weight',
        bio: 'organic',
        vegan: 'vegan',
        lf: 'lactose free',
        gf: 'gluten free',
        preOrderItem: 'Pre order item',
        msc: 'MSC - Certified sustainable seafood',
        asc: 'ASC - Farmed responsibly',
        amagenuss: 'AMA Genussregion'
      },
      virtualCategories: {
        RIED: 'OurTipp',
        COOK: 'Cook',
        NATUR: 'Natürlich für uns',
        ECO: 'TransGourmet Economy',
        NAT: 'TransGourmet Natura',
        PREMI: 'TransGourmet Premium',
        QUALI: 'TransGourmet Quality',
        VONA: 'TransGourmet Vonatur',
        CONVI: 'Convenience',
      }
    },
    category: {
      categories: 'Categories',
    },
    customer: {
      customer: 'Customer',
      customerWithId: '@:common.customer.customer {customerId}',
      customerNumber: 'Customer number',
      withNumber: '@:common.customer.customer {customerNumber}',
      address: {
        deliveryAddress: 'Delivery address',
        unloadingArea: 'Unloading area',
        customerAddress: 'Address',
      }
    },
    cart: {
      cart: 'Cart',
      addToCart: 'Add to cart',
      inCart: 'In cart',
      quantityChangedInCart: 'Quantity in cart has changed.',
      unitChangedInCart: 'Unit in cart has changed.',
    },
    order: {
      order: 'Order',
      orderNumberWithId: 'Order number {orderId}',
      orderNumberWithIdInHtml: 'Order number {0}', // we need to use unnamed variables because <i18n> blocks
      // cant handle named variables in current i18n version.
      orderWithId: 'Order {orderId}',
      deliveryDate: 'Delivery date',
      customerOrderNumber: 'Reference',
      customerOrderNumberWithId: 'Your reference {customerOrderId}',
      item: {
        items: 'Order items'
      }
    },
    amountSelector: {
      error: {
        invalidAmount: 'Invalid quantity - minimum quantity: {lowerBound}',
        invalidAmountForProduct: 'Invalid amount for product {sku} {productName} - minimum quantity: {minQty}'
      }
    },
    labelSelection: {
      removeFromLabelPrintList: 'Remove from label print list',
      addToLabelPrintList: 'Add to label print list'
    },
    orderTemplateSelection: {
      addToOrderTemplate: 'Add to order template',
      removeFromOrderTemplate: 'Remove from order template',
    },
    inventory: {
      inventories: 'Inventories'
    },
    customerSelector: {
      error: {
        noActiveCustomers: 'You do not have any active customers assigned. ' +
          'Please get in touch with our Transgourmet customer service.'
      },
    },
  },
  header: {
    customerSelector: {
      myAccount: '@:common.user.myAccount',
      customerWithId: '@:common.customer.customerWithId',
      changeCustomer: 'Change customer',
      myOrders: 'My orders',
      documents: 'Documents',
      inventories: '@:common.inventory.inventories',
      downloadLmivList: 'Download list of allergens',
      changePassword: '@:common.user.changePassword',
      logout: '@:global.logout',
      noActiveCustomers: '@:global.customerSelector.error.noActiveCustomers',
    },
    messageBar: {
      pleaseMakeSureYouHaveInternet: 'Please make sure that you are connected to the internet.'
    },
    orderListsDropdown: {
      orderLists: 'Order lists',
      orderTemplates: 'Order templates',
      bfOrders: '@:bfOrder.bfOrders',
    },
    userMenu: {
      myAccount: '@:common.user.myAccount',
      changePassword: '@:common.user.changePassword',
      logout: '@:global.logout'
    },
    shoppingCart: '@:common.cart.cart'
  },
  searchForm: {
    searchPlaceHolder: 'I am looking for ...',
    showAllResults: 'in Stocklist',
    showEssenceResults: 'in Essence',
    showAllProductsFor: 'Show {totalAmount} products for: "{query}"',
    categories: '@:common.category.categories',
    articles: '@:common.product.products',
    searchAutoCompletionProduct: {
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    }
  },
  searchResult: {
    productBadges: {
      specialPriceAbbr: 'Special',
      promotionPriceAbbr: 'Promotion'
    },
    resultShoppingCartControl: {
      productHasBeenRemovedFromTemplate: '{0} has been removed from template.',
      restore: '@:global.restore',
      sponsored: 'Sponsored',
      addToCart: '@:common.cart.addToCart',
      inCart: '@:common.cart.inCart',
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      productHasChangedInTemplate: 'Product has been changed in your template.',
      remove: '@:global.remove',
      saveChangesInTemplate: 'Save changes in template',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    }
  },
  cartPage: {
    header: {
      totalPrice: '@:global.totalPrice',
      continueShopping: 'Continue shopping',
      customerWithNumber: '@:common.customer.customer: {customerId}',
      username: '@:common.user.username: {username}',
      steps: {
        cart: '@:common.cart.cart',
        delivery: 'Delivery details',
        confirmation: 'Confirmation',
        buttonCaption: {
          goToDeliveryDetails: 'Continue to delivery',
          submitOrder: 'Submit order'
        }
      }
    },
    preOrderSection: {
      preOrderItemDeliveryTimeNote: 'The following products might take us longer to deliver',
      numberOfPreOrderItems: 'No pre order items | 1 pre order item | {totalItems} pre order items',
      preOrderItem: {
        noImageAvailable: '@:global.noImageAvailable',
        product: '@:common.product.product',
        amount: '@:global.amount',
        inBaseUnit: '@:common.product.inBaseUnit',
        pricePerUnit: '@:common.product.pricePerUnit',
        totalPrice: '@:global.totalPrice',
      }
    },
    cartStep: {
      bfOrders: '@:bfOrder.bfOrders',
      bfOpenOrders: 'No open orders | 1 open order | {count} open orders', // example for pluralisation
      buttonBfOpenOrders: 'Go to open Order Friend orders',
      totalProductsInCart: 'No products in cart | 1 product in cart | {totalItems} products in cart',
      confirmEmptyDialog: {
        emptyCart: 'Empty cart',
        doYouReallyWantToEmpty: 'Do you really want to empty your cart?',
      },
      cartIsEmpty: 'You do not have any products in your cart.',
      promotionTitle: 'Already tried?',
      cartItem: {
        noImageAvailable: '@:global.noImageAvailable',
        preOrderItem: '@:common.product.attributes.preOrderItem',
        itMightTakeLongerToDeliver: 'It might take us longer to deliver',
        remove: '@:global.remove',
        productHasBeenRemoved: '{0} has been removed from cart.',
        restore: '@:global.restore',
      },
      promotedProduct: {
        noImageAvailable: '@:global.noImageAvailable',
        addToCart: '@:common.cart.addToCart',
      },
      unavailableItems: {
        title: 'Unavailable items:',
        removeAll: 'Remove all'
      }
    },
    deliveryStep: {
      delivery: 'Delivery',
      yourReference: 'Your reference',
      reference: '@:common.order.customerOrderNumber',
      deliveryDate: '@:common.order.deliveryDate',
      deliveryAddress: '@:common.customer.address.deliveryAddress',
      unloadingArea: '@:common.customer.address.unloadingArea',
      order: '@:common.order.order',
      totalProducts: 'No products | 1 product | {totalItems} products',
      totalPrice: '@:global.totalPrice',
      customerData: 'Customer data',
      customerNumber: '@:common.customer.customerNumber',
      customerAddress: '@:common.customer.address.customerAddress',
      paymentMethod: {
        paymentMethod: 'Payment method',
        invoice: 'Purchase on account'
      },
      confirmationMailTo: 'Confirmation mail is sent to',
      noReceiversAvailable: 'No receivers available.',
      editMailReceivers: '@:global.edit',
      notes: '@:global.notes',
      youCanAddCommentsForYourOrderHere: 'Here you can add comments on you order.'
    },
    confirmationStep: {
      thankYouForYourOrder: 'Thank you for your order.',
      yourOrderHasBeenPlacedSuccessfully: 'Your order has been placed successfully!',
      orderNumberWithId: '@:common.order.orderNumberWithId',
      orderNumberWithIdInHtml: '@:common.order.orderNumberWithIdInHtml',
      customerOrderNumberWithId: '@:common.order.customerOrderNumberWithId',
      downloadPdf: '@:global.downloadPdf',
      viewOrder: 'View order',
      anOrderConfirmationMailWillBeSentTo: 'An order confirmation e-mail will be sent to the following e-mail ' +
        'addresses:',
      yourOrder: 'Your order',
      totalPrice: '@:global.totalPrice',
      orderItems: '@:common.order.item.items',
      customerWithNumber: '@:common.customer.customer {0}',
      orderedOnBy: 'Ordered on {orderDate} by {orderedBy} via webshop.',
      yourDelivery: 'Your devliery',
      deliveryAddress: '@:common.customer.address.deliveryAddress',
      unloadingArea: '@:common.customer.address.unloadingArea',
      notes: '@:global.notes',
      deliveryDateUnknown: 'Delivery date unknown',
      noConfirmationMailAvailable: 'No e-mail addresses available'
    }
  },
  bfOrder: {
    bfOrders: 'Order Friend orders',
    deliveryAddressAndUnloadingArea: '@:common.customer.address.deliveryAddress - ' +
      '@:common.customer.address.unloadingArea',
    createdOn: 'Created on',
    products: '@:common.product.products',
    totalPrice: '@:global.totalPrice',
    confirmDeleteDialog: {
      delete: '@:global.delete',
      doYouReallyWantToDelete: 'Do you really want to delete this open Order Friend order?'
    },
    addToCart: '@:common.cart.addToCart',
    error: {
      productsHaveBeenCaptured: 'You captured the following products on your Order Friend which could not be imported:',
      productsCouldNotBeImported: 'You captured the following products on your Order Friend which could not be ' +
        'imported: {0}. These products could not be imported because the products or the selected units are not ' +
        'sold anymore.',
      deliveryAddressOrUnloadingAreaDoesNotExist: 'The delivery address or unloading area you selected on your ' +
        'Order Friend device does not exist anymore. Please select a correct delivery address during checkout.'
    },
    item: {
      noImageAvailable: '@:global.noImageAvailable',
      amount: '@:global.amount',
      salesUnit: '@:common.product.salesUnit',
      pricePerUnit: '@:common.product.pricePerUnit',
      totalPrice: '@:global.totalPrice',
    }
  },
  cms: {
    featuredProduct: {
      noImageAvailable: '@:global.noImageAvailable',
      invalidAmountForProduct: '@:common.amountSelector.error.invalidAmountForProduct'
    },
    featuredProducts: {
      noPromotionsCurrently: 'Derzeit keine Aktionen verfügbar'
    },
    promoProducts: {
      noImageAvailable: '@:global.noImageAvailable',
    },
    teaserTiles: {
      readMore: '@:global.readMore'
    }
  },
  cookieNotice: {
    thisSiteUsesCookies: 'Our webshop uses cookies and tracking-tools to improve the quality of our services. ' +
      'With this data we are able to continually improve our user-experience. ' +
      'For more information see the imprint or the data-protection page.',
    header: 'We value your privacy',
    essential: 'Essential',
    statistics: 'Statistics',
    onlySelectedCookies: 'Only selected',
    allCookies: 'Accept all',
    showDetails: 'Show details',
    hideDetails: 'Hide details',
    matomoDescription: 'With the given analysis-tools we are able to better understand the behaviour of our users. ' +
      'The analysis-result gives us the possibility to enhance our services in the future. ' +
      'This option enables for instance the tracking of page-visits and cart-events'
  },
  essential: {
    addAllEssencesToLabelSelectionButton: {
      addAllToLabelPrint: 'Add all to label print',
      doYouReallyWantToAddAll: 'Do you really want to add all products to your label print list?'
    },
    essenceHideButton: {
      visibleOnEssenceList: 'Visible on essence list',
      hiddenOnEssenceList: 'Hidden on essence list'
    }
  },
  inventories: {
    inventoriesDeleteButton: {
      delete: '@:global.delete',
      doYouReallyWantToDelete: 'Do you really want to delete this inventory?',
      inventoryWithItemsHasBeenDeleted: 'Inventory created on {inventoryDate} with {totalItems} item ' +
        'has been deleted! | Inventory created on {inventoryDate} with {totalItems} items has been deleted!'
    }
  },
  labelPrint: {
    labelPrint: 'Label print',
    generateLabelList: 'Generate list of labels',
    confirmEmptyDialog: {
      emptyList: 'Empty label print list',
      doYouReallyWantToEmpty: 'Do you really want to empty the label print list?'
    },
    productsInLabelPrintList: 'No items in label print list | 1 item in label print list | ' +
      '{totalItems} items in label print list',
    item: {
      remove: '@:global.remove',
      productHasBeenRemoved: '{0} has been removed from label print list.',
      restore: '@:global.restore',
      productWithSku: '@:common.product.withSku'
    }
  },
  orderTemplate: {
    orderTemplateButtons: {
      addAllToCart: 'Add all to cart',
      setQuantityZero: 'Set quantity fields to 0',
      downloadAsPdf: 'Download PDF',
      allProductsWithQuantityHaveBeenAddedToCart: 'All products with a quantity greater than 0 have been added to cart.'
    },
    orderTemplateDeleteButton: {
      deleteTemplate: 'Delete template',
      doYouReallyWantToDelete: 'Do you really want to delete this order template?'
    },
    orderTemplateEditForm: {
      createdByOn: 'Created by {userName} {createdDate}', // 'am'/'on' is added to createdDate variable automatically
      todayWithDate: 'today, {date}',
      onDayWithDate: 'on {date}',
      updatedByOn: 'Updated by {userName} {updatedDate}',
      yourPersonalNotes: 'Your personal notes',
      showNotes: 'Show notes',
      hideNotes: 'Hide notes',
    },
    orderTemplatePdfButton: {
      downloadAsPdf: '@:orderTemplate.orderTemplateButtons.downloadAsPdf',
      onlyText: 'Only text',
      includeImagesAndBarcodes: 'Include images and barcodes',
      generate: '@:global.generate',
      cancel: '@:global.cancel'
    },
  },
  fair: {
    deliveryStep: {
      requestedDeliveryDayFreshProducts: 'Requested delivery date (fresh)',
      requestedDeliveryDay: 'Requested delivery date (dry)'
    },
    product: {
      priceBadge: 'Special offer'
    }
  },
  productDetail: {
    detailPurchaseSection: {
      tieredPrices: '@:common.product.tieredPrices',
      addToCart: '@:common.cart.cart',
      inCart: '@:common.cart.inCart',
      priceForQuantityAndAbove: 'For and above {minQuantity} {unit}',
      quantityChangedInCart: '@:common.cart.quantityChangedInCart',
      unitChangedInCart: '@:common.cart.unitChangedInCart',
      invalidAmount: '@:common.amountSelector.error.invalidAmount',
      fromQuantityAndAbove: 'from {minQuantity} {unit} up'
    },
    essenceList: {
      visibleOnEssenceList: '@:essential.essenceHideButton.visibleOnEssenceList',
      hiddenOnEssenceList: '@:essential.essenceHideButton.hiddenOnEssenceList',
      days: 'day | days',
      weeks: 'week | weeks',
      months: 'month | months',
      aTimeFrameAgo: '{timeFrame} ago'
    },
    productInformation: {
      productDescription: '@:common.product.productDescription',
      ingredients: '@:common.product.ingredients',
      storageNote: '@:common.product.storageNote',
      allergens: '@:common.product.allergens',
      containedAllergens: 'Contained allergens',
      noImageAvailable: '@:global.noImageAvailable',
      containedTracesOfAllergens: 'Contained traces of allergens',
      documents: 'Documents',
      dataSheet: 'Data sheet'
    },
    productProperties: {
      specialPriceValidUntil: 'SPECIAL PRICE {0}',
      promotionPriceValidUntil: 'PROMOTION PRICE {0}',
      priceValidUntil: 'valid until {priceToDate}',
      product: '@:common.product.product',
      netQuantity: '@:common.product.netQuantity',
      basePrice: '@:common.product.basePrice',
      grossPrice: 'RRP',
    },
  },
  notifications: {
    webshop: 'Webshop',
    sms: 'SMS',
    email: 'E-Mail',
    save: 'Save changes'
  },
  notificationCenter: {
    filter: 'Filter',
    filterAll: 'Type: All',
    markRead: 'Mark as read',
    attachment: 'Attachment',
    youHave: 'You have',
    unreadMessage: 'unread message.',
    unreadMessages: 'unread messages.',
    checkAll: 'check all unread'
  },
  notificationModal: {
    furtherImportantNotifications: 'There are further important messages:'
  },
  addToCart: {
    cart: '@:common.cart.cart',
    inCart: '@:common.cart.inCart',
    preOrderBold: 'Pre-order product',
    preOrderSuffix: ' - please order by phone!',
    notDeliverable: 'Product currently not available!',
    conviItem: 'Order until 2pm for next-day delivery!',
  }
};
